// extracted by mini-css-extract-plugin
export var createdDate = "_nf-1";
export var divider = "_nf-2";
export var headerDivider = "_nf-3";
export var messagesCard = "_nf-0";
export var messagesContainer = "_nf-6";
export var messagesContainerWrapper = "_nf-4";
export var showLeftPanelButton = "_nf-8";
export var topButtons = "_nf-7";
export var withPadding = "_nf-5";